import { Bounds, namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ContainerItem from './containerItem';

namespace('Ofcs.Editor.Item');

/**
 * @class BoxItem
 * @extends ContainerItem
 */
export default window.Ofcs.Editor.Item.BoxItem = ContainerItem.extend({

    type: 'box',

    defaults: {
        /**
         * @property {string} Type
         */
        type: null,

        /**
         * Current position
         * @property {Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Width of the internal area
         * @property {number} attributes.width
         */
        width: 0,

        /**
         * Height of the internal area
         * @property {number} attributes.height
         */
        height: 0,

        /**
         * Depth of the internal area
         * @property {number} attributes.height
         */
        depth: 0,

        /**
         * X coordinate of the internal area
         * @property {number} attributes.internalAreaX
         */
        internalAreaX: 0,

        /**
         * Y coordinate of the internal area
         * @property {number} attributes.internalAreaY
         */
        internalAreaY: 0,

        /**
         * Start of the internal area
         * @property {Point} attributes.internalAreaPosition
         */
        internalAreaPosition: new Point(0, 0),

        /**
         * X of the grid
         * @property {number} attributes.gridWidth
         */
        gridPosition: new Point(0, 0),

        /**
         * Outer box width
         * @property {number} attributes.outerWidth
         */
        outerWidth: 0,

        /**
         * Outer box height
         * @property {number} attributes.outerHeight
         */
        outerHeight: 0,

        /**
         * Outer box depth
         * @property {number} attributes.outerDepth
         */
        outerDepth: 0,

        /**
         * Shape
         * @property {string} attributes.shape
         */
        shape: 0,
    },

    initialize() {
        ContainerItem.prototype.initialize.call(this);
    },

    /**
     * Parses response data into attributes
     *
     * @param {Object} responseParam Response hash
     * @return {Object} Attribute hash
     */
    parse(responseParam) {
        const response = ContainerItem.prototype.parse.call(this, responseParam);

        if (response.internalAreaX !== undefined && response.internalAreaY !== undefined) {
            response.internalAreaPosition = new Point(response.internalAreaX, response.internalAreaY);
        }

        response.position = new Point(0, 0);

        return response;
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getBounds() {
        return new Bounds(
            new Point(0, 0),
            new Point(this.get('outerWidth'), this.get('outerHeight')),
        );
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getMarginBounds() {
        return this.getBounds();
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getInnerBounds() {
        return new Bounds(
            this.get('internalAreaPosition').clone(),
            new Point(
                this.get('internalAreaPosition').x + this.get('width'),
                this.get('internalAreaPosition').y + this.get('height'),
            ),
        );
    },

    getLines() {
        return [];
    },
});
